import { ref } from '@nuxtjs/composition-api';
import { teadsScripts } from '../constants/teads';
import { LANG } from '~/constants/config';
const isTeadsLoaded = ref(false);
export const initializeTeads = (adTags, adConfig, isMobile) => {
  const device = isMobile.value ? 'mobile' : 'desktop';
  if (!isTeadsLoaded.value) {
    const teadsCategory = adConfig.value.fetchData?.value.breadcrumb?.reverse()?.find((category) => {
      return teadsScripts?.[LANG]?.[device]?.hasOwnProperty(category.name);
    });
    const scriptURL = teadsCategory
      ? teadsScripts?.[LANG]?.[device]?.[teadsCategory.name]
      : isMobile.value
      ? undefined
      : teadsScripts?.[LANG]?.[device]?.ROS;
    if (scriptURL) {
      // Teads reklam kodları
      adTags.script.push(
        {
          hid: 'teads',
          src: scriptURL,
          class: 'teads',
          async: true,
          callback: () => {
            // console.log('LOADED Teads');
            isTeadsLoaded.value = true;
          },
        },
        {
          hid: 'teadsAnalyticsInit',
          innerHTML: `
            window.teads_analytics = window.teads_analytics || {};
            window.teads_analytics.analytics_tag_id = "PUB_21080";
            window.teads_analytics.share = window.teads_analytics.share || function() {
            ;(window.teads_analytics.shared_data = window.teads_analytics.shared_data || []).push(arguments)
            };
          `,
        },
        {
          hid: 'teadsAnalytics',
          src: 'https://a.teads.tv/analytics/tag.js',
          async: true,
        }
      );
      adTags.__dangerouslyDisableSanitizersByTagID.teadsAnalyticsInit = ['innerHTML'];
    }
  }
};
